// src/pages/AdminPage.js
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import AdminLayout from '../components/admin/AdminLayout';

function AdminPage() {
  const { user } = useAuth();

  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Bienvenue {user?.name || user?.email}</h1>
      <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16 }}>
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Projets</h3>
          <p>Créer, lister, changer les statuts.</p>
          <Link to="/admin/projects">Ouvrir</Link>
        </div>
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Meetings</h3>
          <p>Suivi des rendez-vous (par deal).</p>
          <Link to="/admin/meetings">Ouvrir</Link>
        </div>
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Tâches</h3>
          <p>Assignations, projets, sprints.</p>
          <Link to="/admin/tasks">Ouvrir</Link>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminPage;
